export enum TabsMenuOptionsRoutes {
  Dados = "dados",
  Disponibilidade = "disponibilidade",
  Taxas = "taxas",
  BloqueioDatas = "bloqueioDatas",
  Fotos = "fotos",
  RegrasReserva = "regrasReserva",
  AreasComumsVinculadas = "areasComunsVinculadas",
}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permission?: string;
}[] = [
  {
    label: "Dados Cadastrais",
    route: TabsMenuOptionsRoutes.Dados,
  },
  {
    label: "Disponibilidade",
    route: TabsMenuOptionsRoutes.Disponibilidade,
  },
  {
    label: "Regras da Reserva",
    route: TabsMenuOptionsRoutes.RegrasReserva,
  },
  {
    label: "Taxas e Métodos de Cobrança",
    route: TabsMenuOptionsRoutes.Taxas,
  },
  {
    label: "Fotos",
    route: TabsMenuOptionsRoutes.Fotos,
  },
  {
    label: "Bloquear Datas",
    route: TabsMenuOptionsRoutes.BloqueioDatas,
  },
  {
    label: "Áreas comuns vinculadas",
    route: TabsMenuOptionsRoutes.AreasComumsVinculadas,
  },
];
